// extracted by mini-css-extract-plugin
module.exports = {"filter-item-wrapper":"PriceRange_filter-item-wrapper__rRmS8","filter-item-container":"PriceRange_filter-item-container__CbsSX"};